export const STEPS = [
  {
    titleKey: "billingOnboarding.firstStep.title",
    descriptionKey: "billingOnboarding.firstStep.description",
  },
  {
    titleKey: "billingOnboarding.secondStep.title",
    descriptionKey: "billingOnboarding.secondStep.description",
  },
  {
    titleKey: "billingOnboarding.thirdStep.title",
    descriptionKey: "billingOnboarding.thirdStep.description",
  },
  {
    titleKey: "billingOnboarding.fourthStep.title",
    descriptionKey: "billingOnboarding.fourthStep.description",
  },
] as const;

export const MIN_PAYMENT_DAY_VALUE = -30;
export const MAX_PAYMENT_DAY_VALUE = 30;
